const Profile = () => (
    <div>
        <h2>Profile</h2>
        <p>Your profile info goes here.</p>
    </div>
);

export default Profile;
